import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";
import { STEPS, fadeUp, stagger } from "./constants";

/**
 * "How it works" — three-step timeline (Escolha → Reserve → Aproveite).
 */
export default function HowItWorks() {
  const { t } = useLang();
  return (
    <motion.section
      id="how"
      className="dt-how"
      data-testid="how-it-works-section"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      variants={stagger}
    >
      <div className="dt-how__inner">
        <motion.p className="dt-section__eyebrow" variants={fadeUp}>{t("landing_how_eyebrow")}</motion.p>
        <motion.h2 className="dt-section__title" variants={fadeUp}>{t("landing_how_title")}</motion.h2>
        <motion.p className="dt-section__desc" variants={fadeUp}>{t("landing_how_desc")}</motion.p>
        <motion.div className="dt-how__grid" variants={stagger}>
          {STEPS.map((step, idx) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={idx}
                className="dt-how__card"
                variants={fadeUp}
                data-testid={`step-${idx + 1}`}
              >
                <div className="dt-how__num">0{idx + 1}</div>
                <div className="dt-how__icon"><Icon size={22} /></div>
                <h3 className="dt-how__title">{t(`landing_step${idx + 1}_title`)}</h3>
                <p className="dt-how__desc">{t(`landing_step${idx + 1}_desc`)}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </motion.section>
  );
}
